import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { FixedLimitStackRoutes, FixedLimitStackScreenProps } from '@/features/account-management/screens/fixed-limit/type';
import { FixedLimitWebOneScreen } from '@/features/account-management/screens/fixed-limit/FixedLimitWebOne.screen';
import { FixedLimitNativeOneScreen } from '@/features/account-management/screens/fixed-limit/FixedLimitNativeOne.screen';

export const FixedLimitConfirm: React.FC<FixedLimitStackScreenProps<FixedLimitStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, data, func, onReturnData, refresh, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <FixedLimitNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <FixedLimitWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      record={record}
    />
  );
};
